import React from 'react';
import '../../NewLook.css';
import '../../crm.css';
import './contactIndicator.css';

export class ContactIndicator extends React.Component {
    renderContactCheckmark() {
        if (this.props.isMyContact) {
            return (
                <div className='icon-mark-icon text-medium color-darkgreen contact-checkmark' />
            );
        }
    }
    
    render() {
        return (
            <div className="relative">
                <div className={`circularLarger_NoShadow gray-centered-background ${this.props.className}`}>
                    <div className='accFont bold center centered-content' title={this.props.contactCount}>
                        {this.props.contactCount}
                    </div>
                </div>
                {this.renderContactCheckmark()}
            </div>
        )
    }
}